import {
  GET_CLIENT_NOTIFICATIONS_REQUEST,
  GET_CLIENT_NOTIFICATIONS_RESPONSE,
  SET_CLIENT_NOTIFICATION_SEEN,
  REPLACE_CLIENT_NOTIFICATION,
  GET_CLIENT_DROPDOWN_NOTIFICATIONS_REQUEST,
  GET_CLIENT_DROPDOWN_NOTIFICATIONS_RESPONSE,
  SET_CLIENT_UNSEEN_NOTIFICATIONS_COUNT,
  ADD_CLIENT_PUSH_NOTIFICATION,
} from "./types";

export const getClientNotificationsRequest = (payload) => ({
  type: GET_CLIENT_NOTIFICATIONS_REQUEST,
  payload,
});

export const getClientNotificationsResponse = (payload) => ({
  type: GET_CLIENT_NOTIFICATIONS_RESPONSE,
  payload,
});

export const setClientNotificationSeenRequest = (payload) => ({
  type: SET_CLIENT_NOTIFICATION_SEEN,
  payload,
});

export const replaceClientNotification = (payload) => ({
  type: REPLACE_CLIENT_NOTIFICATION,
  payload,
});

export const getClientDropdownNotificationsRequest = (payload) => ({
  type: GET_CLIENT_DROPDOWN_NOTIFICATIONS_REQUEST,
  payload,
});

export const getClientDropdownNotificationsResponse = (payload) => ({
  type: GET_CLIENT_DROPDOWN_NOTIFICATIONS_RESPONSE,
  payload,
});

export const setClientUnseenNotificationsCount = (payload) => ({
  type: SET_CLIENT_UNSEEN_NOTIFICATIONS_COUNT,
  payload,
});

export const addClientPushNotification = (payload) => ({
  type: ADD_CLIENT_PUSH_NOTIFICATION,
  payload,
});
